<template>
  <div class="sp-menu">
    <SPMenu
      v-if="menuData && (!sectionName || sectionData)"
      :menu="menuData"
      :section="sectionData"
      :showFootnotes="showFootnotes"
    />
  </div>
</template>

<script>
import axios from "axios";

import SPMenu from "./components/SPMenu.vue";

export default {
  components: {
    SPMenu
  },
  props: {
    // clientSecret: String,
    // clientId: String,
    authHeader: String,
    clientLocationId: String,
    menuName: String,
    sectionName: String,
    showFootnotes: Boolean
  },
  data() {
    return {
      menuData: null,
      sectionData: null
    };
  },
  computed: {
    menuApiPath() {
      return `/locations/${this.clientLocationId}`;
    },
    apiUrl() {
      // Force HTTPS to avoid any scheme-related issues across environments
      return `https://customer-api.singleplatform.com/v1${this.menuApiPath}`;
    }
  },
  mounted() {
    axios.get(this.apiUrl, {headers: {"Authorization": this.authHeader}}).then(({ data: { data } }) => {
      this.menuData = data.menus
        .filter(m => m.name && this.menuName && m.name.toLowerCase() === this.menuName.toLowerCase())
        .shift();
      if (!this.menuData) return;
      if (this.sectionName) {
        const matchedSection = this.menuData.sections
          .filter(s => s.name && s.name.toLowerCase() === this.sectionName.toLowerCase())
          .shift();
        if (matchedSection) this.sectionData = matchedSection;
      }
    });
  }
};
</script>

<style>
.sp-menu {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
li {
  list-style: none;
}
</style>
